import styles from './PlaylistThumbnailGrid.module.scss';

const PlaylistThumbnailGrid = ({ images, isMobile }) => {
  const className = `${styles.playlistThumbnailGrid} ${isMobile ? styles.mobile : ''}`;
  const [first, second, third] = images;

  const thumbnailElements = [first, second, third]
    .filter((image) => typeof image !== 'undefined')
    .map((image) => (
      <div
        className={styles.playlistThumbnailImage}
        key={`thumb-${image}`}
        style={{ backgroundImage: `url(${image})` }}
      />
    ));

  if (images.length <= 2) {
    return <div className={className}>{thumbnailElements}</div>;
  }

  const [primary, ...stack] = thumbnailElements;

  return (
    <div className={className}>
      <div className={styles.playlistThumbnailPrimary}>{primary}</div>
      <div className={styles.playlistThumbnailStack}>{stack}</div>
    </div>
  );
};

export default PlaylistThumbnailGrid;
